import { Link, useSearchParams } from "react-router-dom";
import { useSearch } from "../api";
import { StationFilter, joinSlugs, parseSlugs } from "../components/StationFilter";
import { ErrorBox, Loading } from "../components/State";
import { TrackRow } from "../components/TrackRow";
import { SearchBox } from "../components/SearchBox";
import { useTitle } from "../hooks";

export function Search() {
  const [params, setParams] = useSearchParams();
  const q = params.get("q")?.trim() ?? "";
  const excluded = parseSlugs(params.get("bez"));
  useTitle(q ? `„${q}”` : "Szukaj");
  const { data, isLoading, error } = useSearch(q, {
    limit: 50,
    exclude: excluded.length ? joinSlugs(excluded) : undefined,
  });

  return (
    <>
      <h1>Wyniki wyszukiwania</h1>
      <SearchBox initial={q} />
      <div className="filters">
        <StationFilter
          excluded={excluded}
          onChange={(list) => setParams(list.length ? { q, bez: joinSlugs(list) } : { q })}
        />
      </div>

      {!q && (
        <p className="muted">
          Wpisz tytuł lub wykonawcę. Polskie znaki nie są wymagane: „zolta”
          znajdzie „Żółta”.
        </p>
      )}
      {isLoading && q && <Loading />}
      {error ? <ErrorBox error={error} /> : null}
      {data && (
        <>
          {data.artists.length > 0 && (
            <section aria-labelledby="art">
              <h2 id="art">Wykonawcy</h2>
              <ul className="chips">
                {data.artists.map((a) => (
                  <li key={a.id}>
                    <Link className="chip" to={`/wykonawca/${a.id}`}>
                      {a.name} <small>{a.tracks}</small>
                    </Link>
                  </li>
                ))}
              </ul>
            </section>
          )}
          <section aria-labelledby="trk">
            <h2 id="trk">
              Utwory{" "}
              {data.tracks.length > 0 && (
                <small className="muted">
                  ({data.tracks.length}
                  {data.tracks.length === 50 ? "+" : ""})
                </small>
              )}
            </h2>
            {data.tracks.length === 0 ? (
              <p className="muted">
                Nic nie znaleziono dla „{data.query}”. Spróbuj krótszego
                fragmentu.
              </p>
            ) : (
              <ul className="list">
                {data.tracks.map((t) => (
                  <TrackRow key={t.id} track={t} />
                ))}
              </ul>
            )}
          </section>
        </>
      )}
    </>
  );
}
